// Sort array of object by key
function sortArrayObj(arr, key) {
  return arr?.sort((a, b) => {
    if (a[key] < b[key]) {
      return -1;
    }
    if (a[key] > b[key]) {
      return 1;
    }
    return 0;
  });
}

// Make all lower case and sort array of object by key
function sortArrayObjIcase(arr, key) {
  return arr?.sort((a, b) => {
    if (a[key]?.toLowerCase() < b[key]?.toLowerCase()) {
      return -1;
    }
    if (a[key]?.toLowerCase() > b[key]?.toLowerCase()) {
      return 1;
    }
    return 0;
  });
}

const convertCommaSeperatedToArray = (data) => {
  if (!data) return [];
  if (!data.includes(",")) return [data];
  return data.split(",");
};

const convertArrayToCommaSeperated = (data) => {
  if (!data) return "";
  if (data && data.length === 0) return "";
  if (Array.isArray(data) && data.length > 0) return data.join(",");
  return data;
};

export {
  sortArrayObj,
  sortArrayObjIcase,
  convertCommaSeperatedToArray,
  convertArrayToCommaSeperated,
};
